import { render, staticRenderFns } from "./homeSet.vue?vue&type=template&id=3604f460&scoped=true&"
import script from "./homeSet.vue?vue&type=script&lang=js&"
export * from "./homeSet.vue?vue&type=script&lang=js&"
import style0 from "./homeSet.vue?vue&type=style&index=0&id=3604f460&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3604f460",
  null
  
)

export default component.exports